import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';

import { BaseColumnComponent } from '~components/dynamic-table/column-components/base-column.component';
import { ButtonToggleColumnModel } from '~components/dynamic-table/models/column-types/button-toggle-column.model';
import { Identifyable } from '~core/abstractions/identifyable';
import { ButtonToggleModel } from '~core/models/button-toggle.model';
import { FormControlPipe } from '~core/pipes/form-control.pipe';
import { ButtonToggleGroupComponent } from '../../../button-toggle-group/button-toggle-group.component';

@Component({
    selector: 'arc-button-toggle-column',
    templateUrl: './button-toggle-column.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [ButtonToggleGroupComponent, FormControlPipe]
})
export class ButtonToggleColumnComponent<T extends Identifyable<TId>, TId = number> extends BaseColumnComponent<T, TId> implements OnInit {
    columnItems = signal<ButtonToggleModel<T>[]>([]);

    override ngOnInit(): void {
        super.ngOnInit();
        const buttonToggleColumnModel = this.columnModel as ButtonToggleColumnModel;
        if (buttonToggleColumnModel) {
            this.columnItems.set(buttonToggleColumnModel.options.map(x => ({ value: x.key ?? '', label: x.value ?? '' })));
            if (!buttonToggleColumnModel.isEditable) {
                this.control?.disable();
            }
        }
    }
}
